export class Button {
  constructor(name, type, onClick) {
    this.name = name;
    this.type = type;
    this.onClick = onClick;
  }
}
